<template>
  <div id="products" class="checkout animated fadeIn pb4">
    <!-- desktop view -->
    <div>
      <WebshopHeader>
      </WebshopHeader>
      <div class="clearfix" v-if="loading">
        <div class="col-12">
          <div class="loader"></div>
        </div>
      </div>
      <div class="py4 px3" v-else>
        <div class="pt2">
          <b-alert variant="success" dismissible :show="showCreditSuccess" @dismissed="showCreditSuccess=false">
            <p class="h6 mb0 line-height-4">Dine betalingskortoplysninger er nu registreret og gemt i vores system</p>
          </b-alert>
          <b-alert variant="danger" dismissible :show="showCreditFailed" @dismissed="showCreditFailed=false">
            <p class="h6 mb0 line-height-4">Ikke gennemføres - kontakt venligst Håndværker.dk support på info@haandvaerker.dk</p>
          </b-alert>
        </div>
        <!--<h4 class="darkblue bold">Dine indkøbskurv</h4>-->
        <div class="py3">
          <div class="p0">
            <div class="el-table el-table--fit el-table--enable-row-hover el-table--enable-row-transition" v-if="cartMsg == ''">
              <!-- <div class="right-align">
                <el-pagination
                  small
                  layout="prev, pager, next"
                  :total="parseInt(lastPage)" @current-change="paginationChanged" :current-page="parseInt(curPage)">
                </el-pagination>
              </div> -->
              <!-- <div class="clearfix" v-if="insideLoading">
                <div class="col-12">
                  <div class="loader"></div>
                </div>
              </div>
              <div v-else> -->
              <div>
                <table class="el-table__body col-12 p0">
                  <thead class="has-gutter">
                    <tr>
                      <th colspan="1" rowspan="1" class="el-table_1_column_1 is-leaf">Produkt</th>
                      <th colspan="1" rowspan="1" class="el-table_1_column_1 is-leaf">Antal</th>
                      <th colspan="1" rowspan="1" class="el-table_1_column_1 is-leaf">Pris</th>
                      <th colspan="1" rowspan="1" class="el-table_1_column_1 is-leaf">Sum</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="el-table__row" v-for="(cart,index) in cartData" :key="index">
                      <td class="el-table_1_column_1">
                        <a :href="'#/webshop/product?id='+cart.PRODUCT_ID" class="mintgreen flex items-center">
                          <img :src="'https://newcrm.kundematch.dk' + cart.get_product_image[0].showURL" class="mr1" width="20%" v-if="cart.PRODUCT_GROUP != '9001' && cart.NEED_GRAPHIC_HELP !== 'Yes'">
                          <img :src="cart.IMAGE_URL" class="mr1" width="20%">
                          <span class="bold">{{cart.PRODUCT_NAME}}</span>
                        </a>
                      </td>
                      <td class="el-table_1_column_1 qty">
                        <span>{{parseInt(cart.QUANTITY)}}</span>
                      </td>

                      <td class="el-table_1_column_1 price"><span>{{(parseFloat(cart.PRICE)).toLocaleString("da", {style: "currency", currency: "DKK"}).replaceAll('.', ' ').replaceAll(',', '.')}}</span></td>

                      <td class="el-table_1_column_1 price"><span>{{(parseFloat(cart.PRICE * cart.QUANTITY)).toLocaleString("da", {style: "currency", currency: "DKK"}).replaceAll('.', ' ').replaceAll(',', '.')}}</span></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="mt3"><span class="bold">{{cartMsg}}</span></div>
          </div>
          <div class="lg-flex pt2" v-if="cartMsg == ''">
            <div class="block lg-col-6 mb3">
              <span class="h6 bold">Har du en kupon?</span>
              <div class="mb2"></div>
              <div class="lg-flex">
                <b-form-input id="coupon" placeholder="Indtast din kupon her" class="mr2">
                </b-form-input>
                <b-button type="button" class="py2 px3 m0 line-height-1 gibson not-rounded border-none regular blue-btn" :disabled="disableCheckCoupon" @click="checkCoupon()">TJEK KUPON
                </b-button>
              </div>
              <div class="block">
                <div class="mb2"></div>
                <span class="h6">Rabat: <span class="bold">{{couponValue + ' ' + curOrPerc}}</span> {{couponUnitMsg}}</span>
              </div>
            </div>
            <div class="block lg-col-6 right-align">
              <table class="total-amount inline-block mb1">
                <tr class="h6 bold mediumgrey">
                  <td>Sub Total:</td>
                  <td><span class="sub-total">{{(parseFloat(subTotalAmount)).toLocaleString("da", {style: "currency", currency: "DKK"}).replaceAll('.', ' ').replaceAll(',', '.')}}</span></td>
                </tr>
                <tr class="h6 bold">
                  <td>Levering:</td>
                  <td><span class="total">{{(parseFloat(deliveryFee)).toLocaleString("da", {style: "currency", currency: "DKK"}).replaceAll('.', ' ').replaceAll(',', '.')}}</span></td>
                </tr>
                <tr class="h6 bold">
                  <td>Rabat:</td>
                  <td><span class="total">{{(parseFloat(discount)).toLocaleString("da", {style: "currency", currency: "DKK"}).replaceAll('.', ' ').replaceAll(',', '.')}}</span></td>
                </tr>
                <tr class="h6 bold">
                  <td>Total:</td>
                  <td><span class="total">{{(parseFloat(totalAmount)).toLocaleString("da", {style: "currency", currency: "DKK"}).replaceAll('.', ' ').replaceAll(',', '.')}}</span></td>
                </tr>
              </table>
              <div>
                <div class="col-12 lg-col-8 flex p0 pl-1 mb2 ml-auto left-align">
                  <div class="pr1">
                    <input type="checkbox" class="terms" style="width: 20px; height: 20px;">
                  </div>
                  <div>
                    <div class="mb2">
                      <span><span @click="clickAgreeText()">Jeg har læst og accepteret</span> <a href="#/webshop/terms-and-conditions" target="_blank" rel="noopener noreferrer" class="termsconditions">Vilkårene og Betingelserne</a>.</span>
                    </div>
                    <div class="mb1">
                      <span>OBS:<br>
                      Det er ikke nødvendigt at indtaste betalingsoplysninger, da vi allerede har disse i forbindelse med betalingen af dit medlemskab hos Håndværker.dk</span>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <b-button type="button" class="action-button py2 px3 m0 gibson not-rounded border-none regular" @click="placeOrder()">CHECKOUT
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <WebshopFooter v-if="!loading">
      </WebshopFooter>
    </div>
  </div>
</template>

<script>
import WebshopHeader from './header'
import WebshopFooter from './footer'
import axios from 'axios'
export default {
  name: '',
  components: {
    WebshopHeader,
    WebshopFooter
  },
  data () {
    return {
      loading: true,
      insideLoading: false,
      salesPerson: '',
      haaId: '',
      cartData: [],
      deliveryFee: 0,
      couponId: 0,
      curOrPerc: 'kr',
      couponUnit: '',
      couponUnitMsg: '',
      couponValue: 0,
      changecredit: false,
      credit: '',
      disableCheckCoupon: false,
      currency: 'kr',
      subTotalAmount: 0,
      discount: 0,
      totalAmount: 0,
      cartMsg: 'Ingen Varer I Din Kurv.',
      curPage: 1,
      lastPage: 10,
      showCreditSuccess: false,
      showCreditFailed: false
    }
  },
  created () {
    this.salesPerson = localStorage.getItem('id_token_portal')
    this.haaId = localStorage.getItem('haaid')
    this.getDeliveryFee()
  },
  mounted () {
    var creditTemp = localStorage.getItem('changecredit')
    var creditResult = this.getUrlParameter('credit')
    if (typeof creditTemp !== 'undefined' && creditTemp !== null) {
      this.changecredit = creditTemp
    }
    if (typeof creditResult !== 'undefined' && creditResult !== null) {
      this.credit = creditResult
    }
    if (this.changecredit && this.credit === 'change') {
      this.showCreditSuccess = true
    } else if (this.changecredit && this.credit === 'failed') {
      this.showCreditFailed = true
    }
  },
  methods: {
    showBreadCrumb () {
      document.querySelector('.breadCrumb').classList.remove('hide')
    },
    displayCart () {
      var data = {
        operation: 'bitrixApi',
        salesPerson: this.salesPerson,
        type: 'GET',
        url: 'webshop/GetCart/' + this.haaId + '?page=' + this.curPage
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          console.log(res)
          if (res.success) {
            var dataRes = response.data.data.data[0].webshop_cart_products
            this.cartData = dataRes
            // var accCur = response.data.data.data[0].ACCOUNT_CURRENCY_ID
            var pagLastPage = response.data.data.last_page + '0'
            var price = 0
            var qty = 0
            var discount = 0
            var total = 0
            for (var i = 0; i < dataRes.length; i++) {
              price = dataRes[i].PRICE
              qty = dataRes[i].QUANTITY
              total += price * qty
            }
            if (this.couponUnit === 'CurEach') {
              discount = this.couponValue * dataRes.length
            } else if (this.couponUnit === 'Perc') {
              var coupVal = '0.' + this.couponValue
              discount = total * coupVal
            } else if (this.couponUnit === 'CurAll') {
              discount = this.couponValue
            }
            total = total - discount
            // this.currency = accCur
            if (this.subTotalAmount === 0) {
              if (Number.isInteger(this.subTotalAmount)) {
                if (total % 1 !== 0) {
                  this.subTotalAmount = total + '0'
                } else {
                  this.subTotalAmount = total + '.00'
                }
              } else {
                this.subTotalAmount = total
              }
            }
            this.discount = parseInt(discount)
            if (Number.isInteger(this.discount)) {
              this.discount = this.discount + '.00'
            }
            this.totalAmount = total + parseInt(this.deliveryFee)
            if (this.totalAmount % 1 !== 0) {
              this.totalAmount = this.totalAmount + '0'
            } else {
              this.totalAmount = this.totalAmount + '.00'
            }
            this.lastPage = pagLastPage
            if (!dataRes.length) {
              this.cartMsg = 'Ingen Varer I Din Kurv.'
            } else {
              this.cartMsg = ''
            }
            this.showBreadCrumb()
            this.loading = false
          } else {
            this.showBreadCrumb()
            this.loading = false
            console.log('Error in displayCart()')
          }
        },
        (response) => {
          console.log('Error: ', response)
        }
      )
    },
    getDeliveryFee () {
      var data = {
        operation: 'bitrixApi',
        salesPerson: this.salesPerson,
        type: 'GET',
        url: 'webshop/GetWebshopDeliveryChargeDynamic/9001' // static for badges
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            this.deliveryFee = res.data.PRICE
            this.displayCart()
          } else {
            console.log('Error in getDeliveryFee()')
          }
        },
        (response) => {
          console.log('Error: ', response)
        }
      )
    },
    checkCoupon () {
      const coupon = document.getElementById('coupon').value
      if (coupon !== '') {
        var data = {
          operation: 'bitrixApi',
          salesPerson: this.salesPerson,
          type: 'GET',
          url: 'webshop/CheckCoupon/' + coupon
        }
        this.$http.post('', data, { emulateJSON: true }).then(
          (response) => {
            var res = response.body
            if (res !== '' && res !== null) {
              this.couponId = res.ID
              this.couponValue = res.value
              if (res.success) {
                if (res.unit === 'Perc') {
                  this.curOrPerc = '%'
                  this.couponUnit = res.unit
                  this.couponUnitMsg = 'af det samlede beløb'
                } else if (res.unit === 'CurEach') {
                  this.curOrPerc = this.currency
                  this.couponUnit = res.unit
                  this.couponUnitMsg = 'af hver vare'
                } else if (res.unit === 'CurAll') {
                  this.curOrPerc = this.currency
                  this.couponUnit = res.unit
                  this.couponUnitMsg = 'af det samlede beløb'
                }
                this.displayCart()
                this.disableCheckCoupon = false
                this.$toastr('success', 'Kuponen er aktiv')
              } else {
                if (res.unit === '') {
                  this.curOrPerc = this.currency
                  this.couponUnit = res.unit
                  this.couponUnitMsg = ''
                }
                this.displayCart()
                this.disableCheckCoupon = false
                this.$toastr('error', 'Kupon findes ikke')
              }
            } else {
              this.displayCart()
              this.disableCheckCoupon = false
              this.$toastr('error', 'Kupon findes ikke')
            }
          },
          (response) => {
            console.log('Error: ', response)
          }
        )
        this.disableCheckCoupon = true
      } else {
        this.couponId = 0
        this.curOrPerc = this.currency
        this.couponUnit = ''
        this.couponUnitMsg = ''
        this.couponValue = 0
        this.displayCart()
        this.$toastr('error', 'Indtast din kupon')
      }
    },
    getUrlParameter (param) {
      var pageUrl = window.location.search.substring(1)
      var urlVar = pageUrl.split('&')
      var parameterName
      var i
      for (i = 0; i < urlVar.length; i++) {
        parameterName = urlVar[i].split('=')
        if (parameterName[0] === param) {
          return parameterName[1] === undefined ? true : decodeURIComponent(parameterName[1])
        }
      }
    },
    changeCredit () {
      var data = {
        salesPerson: this.salesPerson,
        operation: 'confirm_change_credit',
        type: 'POST'
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        (response) => {
          var res = response
          var resData = response.data
          if (res.status === 200) {
            this.changecredit = resData.changecredit
            localStorage.setItem('changecredit', resData.changecredit)
            setTimeout(() => {
              window.location.href = 'https://www.kundematch.dk/newpartner/kredit.php?id=' + this.salesPerson + '&mode=shop'
            }, 500)
          }
        },
        (response) => {
          console.log('Error: ', response)
        }
      )
    },
    placeOrder () {
      var termsAndConditions = document.querySelector('.terms')
      if (termsAndConditions.checked === true) {
        if (this.credit === '') {
          this.changeCredit()
        }
        if (this.changecredit && this.credit === 'failed') {
          return
        }
        const coupId = this.couponId
        var data = {
          operation: 'bitrixApi',
          salesPerson: this.salesPerson,
          type: 'POST',
          url: 'webshop/PostOrder/' + this.haaId,
          createinvoice: true,
          parameters: JSON.stringify({
            CouponID: coupId
          })
        }
        this.$http.post('', data, { emulateJSON: true }).then(
          (response) => {
            var res = response.body
            if (res.success) {
              var orderId = res.InvoiceNumber
              var generatedOrderId = this.haaId + '' + Date.now()
              var amount = this.totalAmount
              axios({
                method: 'POST',
                url: 'https://www.kundematch.dk/crm/libraries/productform/product.php?mode=checkinvoice&addsid=' + orderId,
                createinvoice: true,
                orderid: generatedOrderId,
                price: amount,
                headers: {
                },
                data: {
                }
              }).then(response => {
                var res = response.data
                if (res.success) {
                  if (res.result.paid) {
                  }
                  sessionStorage.setItem('placeOrder', true)
                  this.$router.push('/webshop/orders')
                } else {
                  this.$toastr('error', 'Fejl')
                }
              }).catch(error => {
                console.log('Error: ', error)
              })
            } else {
              this.$toastr('error', 'Fejl')
              console.log('Error in placeOrder()')
            }
          },
          (response) => {
            console.log('Error: ', response)
          }
        )
        this.loading = true
      } else {
        this.$toastr('error', 'Accepter venligst vilkårene og betingelserne')
      }
    },
    paginationChanged (val) {
      var pagCurPage = (`${val}`)
      this.curPage = pagCurPage
      this.displayCart()
      this.insideLoading = true
    },
    clickAgreeText () {
      var termsAndConditions = document.querySelector('.terms')
      if (termsAndConditions.checked === true) {
        termsAndConditions.checked = false
      } else {
        termsAndConditions.checked = true
      }
    }
  }
}
</script>

<style>
  .checkout div .el-table td, .el-table th {
    width: 25%;
    padding: 1rem;
  }
  .checkout .mobile-view div .el-table td, .el-table th {
    width: 33%;
  }
  .checkout .blue-btn {
    background: #19a3c0;
  }
  .checkout .blue-btn:hover {
    background: #4dcf55;
  }
</style>


// WEBPACK FOOTER //
// checkout.vue?190107e2